<template>
  <div id="container" :type="pageType" v-ga:page="{pageType, glb}" v-ga:request="{pageType, glb}">
    <mvtHeader :geoInfo="glb.geo"/>
    <neighborhoodMap
        :geo="geo"
        :boundary="boundary"
        :listings="neighborhood.relatedListings.nearby"
        :weather="weatherSummary"
    />
    <div class="container grid fixed grid-cols-12">

      <div class="col-span-12">
        <div class="title-container">
          <neighborhoodScores :scores="locationScores"/>
          <section class="title">
            <div class="f4 text-bold">{{ geo.city }}, {{ geo.state }}</div>
            <h1 class="f0 text-bold">{{ geo.neighborhoodName }}</h1>
          </section>
        </div>
        <section class="description">
          <h2 class="f2 text-bold">About {{ geo.neighborhoodName }}</h2>
          <p>
            {{ description }}
          </p>
          <ul class="similar-neighborhoods" v-if="similarNeighborhoods?.length > 0">
            <li><span>Similar Neighborhoods:</span></li>
            <li v-for="hood in similarNeighborhoods" :key="hood.name">
              <a :href="hood.path">
                <span class="new-tag tag small">{{ hood.name }}</span>
              </a>
            </li>
          </ul>
          <button class="btn primary regular" @click="openHotlead"><i class="icon-user-home"></i> Connect with agent</button>
        </section>
        <SplitTreatments v-if="glb.isUserBrowser" :names="['movoto-nearby-video-CW-2495']">
           <template #default="{ treatments, isReady }">
              <section v-if="isReady && treatments['movoto-nearby-video-CW-2495'] === 'on'">
                <h2 class="f2 text-bold m-b-2">Explore {{ geo.neighborhoodName }}</h2>
                <mvtNearbyVideo/>
              </section>
            </template>
        </SplitTreatments>
        <section class="explore">
          <tabGroup :tabs="tabs" :initialTab="initialTab" eventCategory="np_tabs" eventAction="click_custom">
            <template v-slot:tab-head-housing>
              Housing
            </template>
            <template v-slot:tab-panel-housing>
              <exploreHousing
                :snapshotData="snapshotData"
                :geo="geo"
                :appUrl="glb.appUrl"
                :avgPrice="avgPrice"
                :avgSize="avgSize"
              />
            </template>
            <template v-slot:tab-head-school>
              Schools
            </template>
            <template v-slot:tab-panel-school>
              <exploreSchools
                :schools="categorizedSchoolsList"
              />
            </template>
            <template v-slot:tab-head-places>
              Places
            </template>
            <template v-slot:tab-panel-places>
              <SplitTreatments :names="['movoto-place-CW-2398']">
                  <template #default="{ treatments, isReady }">
                      <template v-if="isReady && treatments['movoto-place-CW-2398'] === 'on'">
                        <mvtNearbyPlaces/>
                      </template>
                      <template v-else>
                        <explorePois :pois="pois" />
                      </template>
                  </template>
              </SplitTreatments>
            </template>
            <template v-slot:tab-head-agents>
              Agents
            </template>
            <template v-slot:tab-panel-agents>
              <div v-if="loading" class="loadingContainer"></div>
              <exploreAgents v-else-if="!loading && !!agents"
                :agents="agents"
                :neighborhoodName="geo.neighborhoodName"
                :openHotlead="openHotlead"
              />
            </template>
          </tabGroup>
        </section>
      </div>
    </div>

    <mvtFooter :geoInfo="glb.geo" />
    <mvtPopSignin />
    <mvtDialogCenter />
    <mvtToastCenter />
  </div>
</template>

<script src="./index.js" />

<style lang="scss">
  @use "./index.scss" as *;
</style>